import * as React from 'react';
import * as cost from './style.module.scss';
import { Modal } from '../../../../Modal';
import { GetCourseWidget } from '../../../../GetCourseWidget';
import { TaxDeduction } from '../../../../TaxDeduction';
export const Cost = () => {
  const [showModalFull, setShowModalFull] = React.useState(false);
  return (
    <section className={cost.cost} id="user-action">
      <div className="container">
        <h3>
          Стоимость курса
          <br />
          «Как научить ребёнка читать быстро и с умом»
        </h3>
        <div className={cost.cost__blocks}>
          <div className={cost.cost__block}>
            <div className={cost.cost__blockHeader}>
              <h4>
                <span>Пакет</span>
                <br />
                «Три в одном»
              </h4>
            </div>
            <div className={cost.cost__blockContent}>
              <div className={cost.cost__blockItem}>
                <p>Видеоуроки для родителей</p>
              </div>
              <div className={cost.cost__blockItem}>
                <p>Книга — практическое пособие для тренировки чтения</p>
              </div>
              <div className={cost.cost__blockItem}>
                <p>Доступ к платформе-тренажёру с упражнениями</p>
              </div>
            </div>
          </div>
          <div className={cost.cost__prices}>
            <div className={cost.cost__pricesBlock}>
              <h5 className={cost.cost__pricesHeader}>Полный доступ к курсу</h5>

              <ul className={cost.cost__pricesList}>
                <li className={cost.cost__pricesItem}>Доступ к курсу на&nbsp;2&nbsp;года</li>
                <li className={cost.cost__pricesItem}>
                  Беспроцентная рассрочка
                  <br />
                  на 10 месяцев
                </li>
              </ul>

              <div className={cost.cost__pricesBuy}>
                <p className={cost.cost__pricesText}>Стоимость</p>
                <p className={cost.cost__pricesPrice}>45 900 ₽</p>
                <button
                  className={cost.cost__pricesButton}
                  onClick={() => {
                    setShowModalFull(true);
                  }}
                >
                  Купить курс
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className={cost.cost__undertext}>
          <p>Все наши курсы можно приобрести по материнскому капиталу</p>
        </div>
        <div className={cost.cost__undertext}>
          <TaxDeduction />
        </div>
      </div>

      <Modal
        open={showModalFull}
        onClose={() => {
          setShowModalFull(false);
        }}
      >
        <GetCourseWidget hash={'a38c25b9c71b4907dd57df135c7cc04200326133'} id={'739051'} />
      </Modal>
    </section>
  );
};
